import { render, staticRenderFns } from "./itemEdit.vue?vue&type=template&id=ba7e7e7e"
import script from "./itemEdit.vue?vue&type=script&lang=js"
export * from "./itemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports